import HttpService from "../util/HttpService";
import {JointAccountWrapperDto} from "../dto/JointAccountWrapperDto";
import {IndividualAccountWrapperDto} from "../dto/IndividualAccountWrapperDto";
import {JointAccountAcceptOrRejectInputDto} from "../dto/JointAccountAcceptOrRejectInputDto";
import {JointAccountTemplateDto} from "../dto/JointAccountTemplateDto";
import {SecondApplicantDetailDto} from "../dto/SecondApplicantDetailDto";
import ParamEncrypt from "../util/ParamEncrypt";
import {ThirdPartyBankFilterDto} from "../dto/ThirdPartyBankFilterDto";
import {ThirdPartyBankDetailsDto} from "../dto/ThirdPartyBankDetailsDto";

const CONTEXT_PATH = "/cwm/api/v2";
const SERVICE_PATH = "/account-service/";

class AccountService {

    // get pending task lists of detail,video,customer
    getAccountListByLoggedUsername = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-account-list-by-username"));
    }

    saveAccountDetailWithSecondApplicantData = (data: JointAccountWrapperDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("save-second-applicant-details"), ParamEncrypt.encryptObject(data));
    }
    createIndividualAccountInExistingFlow = (data: IndividualAccountWrapperDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("create-individual-account"), ParamEncrypt.encryptObject(data));
    }
    getPendingJointAccountRequests = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-joint-account-request/").concat(ParamEncrypt.encryptData(cinNumber)));
    }
    acceptOrRejectJointAccountRequest = (data: JointAccountAcceptOrRejectInputDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("accept-or-reject-joint-account-request"), ParamEncrypt.encryptObject(data));
    }
    checkAndRequestJointAccountTemplateRequest = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("check-and-request-joint-account-template-request/").concat(ParamEncrypt.encryptData(cinNumber)));
    }
    getJointAccountHoldersBankAccounts = (reference: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-joint-account-holders-bank-accounts/").concat(ParamEncrypt.encryptData(reference)));
    }

    saveJointAccountTemplate = (data: JointAccountTemplateDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("save-joint-account-template"), ParamEncrypt.encryptObject(data));
    }
    getPendingJointAccountTemplates = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-joint-account-templates/").concat(ParamEncrypt.encryptData(cinNumber)));
    }
    updateSecondApplicantDetails = (data: SecondApplicantDetailDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("update-second-applicant-details"), ParamEncrypt.encryptObject(data));
    }

    getSecondApplicantForUpdate = (reference: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-second-applicant-for-update/").concat(ParamEncrypt.encryptData(reference)));
    }

    cancelJointAccount = (reference: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("cancel-joint-account-request/").concat(ParamEncrypt.encryptData(reference)));
    }
    convertJointAccountIntoIndividualAccount = (reference: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("convert-joint-account-to-individual-account/").concat(ParamEncrypt.encryptData(reference)));
    }

    fetchExistingBankTemplates = (data: ThirdPartyBankFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("fetch-all-third-party-bank-details"), ParamEncrypt.encryptObject(data));
    }

    addNewThirdPartyBankDetails = (data: ThirdPartyBankDetailsDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("add-new-third-party-bank-detail"), ParamEncrypt.encryptObject(data));
    }
    updateThirdPartyBankDetails = (data: ThirdPartyBankDetailsDto) => {
        return HttpService.put(CONTEXT_PATH.concat(SERVICE_PATH).concat("update-third-party-bank-detail"), ParamEncrypt.encryptObject(data));
    }
    deleteThirdPartyBankDetails = (id: string) => {
        return HttpService.deleteOne(CONTEXT_PATH.concat(SERVICE_PATH).concat("delete-third-party-bank-detail/").concat(ParamEncrypt.encryptData(id)));
    }
    fetchExistingBankTemplateById = (id: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-third-party-bank-detail-by-id/").concat(ParamEncrypt.encryptData(id)));
    }
}

const accountService = new AccountService();
export default accountService;